// extracted by mini-css-extract-plugin
export default {"settingsButton":"SettingsButton_settingsButton__YUsIG","icon":"SettingsButton_icon__3imQa","spin":"SettingsButton_spin__3dwsZ"};